import COLORS from 'pared/constants/colors'

import { IConfigsType } from '../../types'

const burgerworksStorePerformance: IConfigsType = {
  burgerworks: {
    '/:brand/store_detail': {
      variables: [
        'date',
        'revenueCenterSales',
        'burgerworksSalesByOrigin',
        {
          type: 'lastTimeRange',
          optionItems: [
            { timeFrame: 'days', lastDateRangeNumber: 7 },
            { timeFrame: 'weeks', lastDateRangeNumber: 4 },
            { timeFrame: 'periods', lastDateRangeNumber: 3 },
            { timeFrame: 'periods', lastDateRangeNumber: 13 },
          ],
        },
      ],
      storePerformanceTitle: {
        type: 'title',
        title: 'locationInfo',
        subTitle: 'storeSubtitle',
      },
      groupFilter: {
        api: 'locationFilter',
      },
      dateFilter: {
        types: [
          'week',
          'period',
          'quarter',
          'year',
          'last_week',
          'this_week',
          'yesterday',
          'trailing_7_days',
          'trailing_90_days',
          'custom',
        ],
        defaultType: 'yesterday',
      },
      storePerformanceList: {
        type: 'list',
        api: 'burgerworksListStorePerformanceKpis',
        fieldWidth: '250px',
        fields: [
          {
            content: {
              key: 'netSales',
            },
            bottom: 'Net Sales',
          },
          {
            content: {
              key: 'netSalesSssPercent',
            },
            bottom: 'YoY %',
          },
          {
            content: {
              key: 'checkCount',
            },
            bottom: 'Check Count',
          },
          {
            content: {
              key: 'checkAverage',
              decimal: 2,
            },
            bottom: 'Check Average',
          },
          {
            width: '125px',
            content: {
              key: 'averageWeeklySales',
            },
            bottom: 'Weekly Sales',
          },
          {
            content: {
              key: 'actualCogsPercent',
            },
            bottom: 'COGS %',
          },
        ],
      },
      storePerformanceTable: {
        type: 'table-v2',
        api: 'burgerworksStorePerformance',
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'date',
            width: '275px',
            useDangerouslySetInnerHTML: true,
          },
          {
            key: 'netSales',
            title: 'Net Sales',
            align: 'center',
            width: '200px',
          },
          {
            key: 'laborTotalCost',
            title: 'Variable Labor',
            align: 'center',
            width: '200px',
          },
          {
            key: 'laborTotalCostPercent',
            title: 'Variable Labor %',
            align: 'center',
            width: '200px',
          },
          {
            key: 'actualCogsPercent',
            title: 'COGS %',
            align: 'center',
            width: '200px',
          },
        ],
      },
      dayPartTableAndChart: {
        type: 'grid',
        children: {
          dayPart: {
            type: 'table-v2',
            api: 'locationDayPart',
            title: 'Day Part',
            row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
            columns: [
              {
                key: 'name',
                title: 'Day Part',
                sortable: true,
              },
              {
                key: 'sales',
                title: 'Sales',
                unit: 'dollar',
                sortable: true,
              },
              {
                key: 'percentSales',
                title: '% Net Sales',
                sortable: true,
              },
              {
                key: 'checkCount',
                title: 'Check Count',
                sortable: true,
              },
              {
                key: 'checkAverage',
                title: 'Check Average',
                unit: 'dollar',
                decimal: 2,
                sortable: true,
              },
            ],
          },
          dayPartPieChart: {
            type: 'pie-chart',
            api: 'locationDayPartPie',
            width: 400,
            label: 'name',
            datasets: [
              {
                key: 'netSales',
                label: 'nameWithPercentage',
                borderColor: COLORS.background,
                backgroundColor: [
                  COLORS.Plum,
                  COLORS.Mango,
                  COLORS.Basil,
                  COLORS.DarkOrchid,
                  COLORS.Acai,
                  COLORS.Pomodoro,
                ],
                hoverOffset: 4,
              },
            ],
            scaleTypes: {
              x: {
                type: 'price',
              },
            },
          },
        },
      },
      revenueCenterBreakdownTable: {
        type: 'table-v2',
        api: 'locationRevenueCenter',
        title: 'Revenue Center',
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'name',
            title: 'Destination',
            sortable: true,
          },
          {
            key: 'sales',
            title: 'Net Sales',
            unit: 'dollar',
            sortable: true,
          },
          {
            key: 'percentSales',
            title: '% Net Sales',
            sortable: true,
          },
          {
            key: 'checkCount',
            title: 'Check Count',
            sortable: true,
          },
          {
            key: 'checkAverage',
            title: 'Check Average',
            unit: 'dollar',
            decimal: 2,
            sortable: true,
          },
        ],
      },
      revenueCenterTrendSalesFilters: {
        type: 'grid',
        children: {
          title: {
            type: 'title',
            title: 'Sales Trend',
          },
          columns: {
            type: 'select',
            value: 'lastTimeRange.value',
            onChange: 'lastTimeRange.onChange',
            options: 'lastTimeRange.options',
          },
        },
      },
      revenueCenterTrendSales: {
        type: 'bar-chart',
        api: 'trendLocationRevenueCenterSales',
        width: 1100,
        height: 800,
        label: 'period',
        datasets: [
          {
            chartType: 'line',
            key: 'netSales',
            label: 'Total Sales',
            borderColor: COLORS.Chalkboard,
            backgroundColor: COLORS.Chalkboard,
          },
          {
            key: '<%- JSON(revenueCenterSales?.options) %>',
          },
        ],
        scaleTypes: {
          y: {
            type: 'price',
          },
        },
        options: {
          scales: {
            x: {
              stacked: true,
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
            y: {
              stacked: true,
            },
          },
        },
      },
      salesByOriginBreakdownTable: {
        type: 'table-v2',
        api: 'burgerworksLocationSalesByOrigin',
        title: 'Sales By Origin',
        row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
        columns: [
          {
            key: 'name',
            title: 'Origin',
            sortable: true,
          },
          {
            key: 'sales',
            title: 'Net Sales',
            unit: 'dollar',
            sortable: true,
          },
          {
            key: 'percentSales',
            title: '% Net Sales',
            sortable: true,
          },
          {
            key: 'checkCount',
            title: 'Check Count',
            sortable: true,
          },
          {
            key: 'checkAverage',
            title: 'Check Average',
            unit: 'dollar',
            decimal: 2,
            sortable: true,
          },
        ],
      },
      salesByOriginTrendSalesFilters: {
        type: 'grid',
        children: {
          title: {
            type: 'title',
            title: 'Sales By Origin Trend',
          },
          columns: {
            type: 'select',
            value: 'lastTimeRange.value',
            onChange: 'lastTimeRange.onChange',
            options: 'lastTimeRange.options',
          },
        },
      },
      salesByOriginTrendSales: {
        type: 'bar-chart',
        api: 'burgerworksTrendLocationSalesByOriginAmount',
        width: 1100,
        height: 800,
        label: 'period',
        datasets: [
          {
            chartType: 'line',
            key: 'netSales',
            label: 'Total Sales',
            borderColor: COLORS.Chalkboard,
            backgroundColor: COLORS.Chalkboard,
          },
          {
            key: '<%- JSON(salesByOrigin?.options) %>',
          },
        ],
        scaleTypes: {
          y: {
            type: 'price',
          },
        },
        options: {
          scales: {
            x: {
              stacked: true,
              ticks: {
                font: {
                  size: 10,
                },
              },
            },
            y: {
              stacked: true,
            },
          },
        },
      },
      discountCompAndLabor: {
        type: 'grid',
        children: {
          discountComp: {
            type: 'table-v2',
            api: 'locationDiscountComp',
            row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
            title: 'Comps',
            columns: [
              {
                key: 'name',
                title: 'Comps',
                sortable: true,
              },
              {
                key: 'amount',
                title: 'Amount',
                unit: 'dollar',
                sortable: true,
              },
              {
                key: 'percentSales',
                title: '% Net Sales',
                sortable: true,
              },
            ],
          },
          laborOverview: {
            type: 'table-v2',
            api: 'locationLaborOverview',
            row: { background: '<%- index % 2 ? colors.Porcelain : "" %>' },
            title: 'Labor Overview',
            columns: [
              {
                key: 'name',
                title: ' ',
                width: '150px',
              },
              {
                key: 'value',
                title: ' ',
                align: 'right',
              },
            ],
          },
        },
      },
      feV2ChatBox: {
        type: 'feV2-chatbox',
        agentType: 'location',
        hideFromNonExpoUsers: true,
        disableInputField: true,
        sendStoreId: true,
        description: 'Ask about your store performance',
        bubblePrompts: [
          {
            id: 'sales',
            label: 'Sales',
            prompt: 'Show me the sales performance',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'sales_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'sales_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'sales_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:sales',
          },
          {
            id: 'daypart',
            label: 'Day Part',
            prompt: 'Show me the sales performance by day part',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'daypart_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'daypart_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'daypart_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:sales-daypart',
          },
          {
            id: 'revenue-center',
            label: 'Revenue Center',
            prompt: 'Show me the sales performance by revenue center',
            children: [
              {
                id: 'yesterday',
                label: 'Yesterday',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'yesterday',
                },
                prompt: 'yesterday',
              },
              {
                id: 'revenue-center_7days',
                label: '7 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_7days',
                },
                prompt: 'over the past 7 days',
              },
              {
                id: 'revenue-center_30days',
                label: '30 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_30days',
                },
                prompt: 'over the past 30 days',
              },
              {
                id: 'revenue-center_90days',
                label: '90 Days',
                params: {
                  type: 'dateRange',
                  periods: ['current', 'previous', 'lastYear'],
                  dateRangeType: 'rolling_90days',
                },
                prompt: 'over the past 90 days',
              },
            ],
            agentCode: 'prompt:sales-revenue-center',
          },
        ],
      },
    },
  },
}

export default burgerworksStorePerformance
